var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkloadsLayersGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "url(#atm-grad)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "atm-grad",
    x1: 0,
    y1: 0,
    x2: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#110A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E1776"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3l8 4-8 4-8-4 8-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11l8 4 8-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15l8 4 8-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkloadsLayersGradient);
export default __webpack_public_path__ + "static/media/workloads-layers-gradient.cb7f8801d3c59f71dc3d2beeaf3acf91.svg";
export { ForwardRef as ReactComponent };